import Vue from "vue";
import VueRouter from "vue-router";
import Home from '@/views/home/Index.vue'
import Homepage from '@/views/homepage/Index.vue'
import Solution from '@/views/solution/Index.vue'
import About from '@/views/about/Index.vue'
import Partner from '@/views/partner/Index.vue'
import Cases from '@/views/cases/Index.vue'
import Experience from '@/views/experience/Index.vue'
import Reservation from '@/views/reservation/Index.vue'



Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "首页",
    component: Homepage,
  },
  {
    path: "/home",
    redirect: "/",
  },
  {
    path: "/real-estate",
    name: "房地产",
    component: Home,
  },
  {
    path: "/industry",
    name: "解决方案",
    component: Solution,
  },
  {
    path: "/industry/real-estate",
    name: "房地产行业解决方案",
    component: Solution,
  },
  {
    path: "/industry/automotive",
    name: "汽车行业解决方案",
    component: Solution,
  },
  {
    path: "/industry/healthcare",
    name: "大健康行业解决方案",
    component: Solution,
  },
  {
    path: "/industry/education",
    name: "教育行业解决方案",
    component: Solution,
  },
  {
    path: "/industry/home-decoration",
    name: "家装行业解决方案",
    component: Solution,
  },
  {
    path: "/solution",
    name: "解决方案",
    component: Solution,
  },
  {
    path: "/solution/crm",
    name: "销冠CRM",
    component: Solution,
  },
  {
    path: "/solution/online-hall",
    name: "线上展厅",
    component: Solution,
  },
  {
    path: "/solution/transaction-manager",
    name: "交易管理",
    component: Solution,
  },
  {
    path: "/solution/precise-customer",
    name: "全渠道获客",
    component: Solution,
  },
  {
    path: "/solution/channel-manage",
    name: "渠道管理",
    component: Solution,
  },
  {
    path: "/solution/intelligent-operate",
    name: "营销自动化",
    component: Solution,
  },
  {
    path: "/solution/smart-scene",
    name: "智慧案场",
    component: Solution,
  },
  {
    path: "/solution/customer-precipitate",
    name: "社群运营",
    component: Solution,
  },
  {
    path: "/solution/data-insight",
    name: "管理驾驶舱",
    component: Solution,
  },
  {
    path: "/solution/sales-empowerment",
    name: "销售赋能",
    component: Solution,
  },
  {
    path: "/solution/visual-display",
    name: "数字沙盘",
    component: Solution,
  },
  {
    path: "/cases",
    name: "成功案例",
    component: Cases,
  },
  {
    path: '/about',
    name: '关于我们',
    component: About,
  },
  {
    path: '/about',
    name: '关于思为',
    component: About
  },
  {
    path: '/partner',
    name: '合作伙伴',
    component: Partner
  },
  {
    path: '/experience',
    name: '立即体验',
    component: Experience
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: Reservation
  },
  {
    path: '/solution/member-marketing',
    name: '会员营销',
    component: Solution
  },
  {
    path: '/solution/omnichannel-acquisition',
    name: '全渠道获客',
    component: Solution
  },
  {
    path: '/solution/lead-conversion',
    name: '线索跟进转化',
    component: Solution
  },
  {
    path: '/solution/marketing-automation',
    name: '自动化营销',
    component: Solution
  },
  {
    path: '/solution/private-domain-growth',
    name: '私域资产持续增值',
    component: Solution
  },
  {
    path: '/solution/community-tools',
    name: '社群运营工具',
    component: Solution
  },
  {
    path: '/solution/private-ecosystem',
    name: '私域生态',
    component: Solution
  },
  {
    path: '/solution/value-activation',
    name: '价值激活',
    component: Solution
  },
  {
    path: '/solution/community-miniprogram',
    name: '社群小程序',
    component: Solution
  },
  {
    path: '/solution/marketing-cloud',
    name: '营销云',
    component: Solution
  }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.path !== '/watch') next()
})

export default router;
